import { Injectable } from '@angular/core';

export class CommandEntry {
    constructor(
        private _name : string, 
        private _summary : string,
        private _handler : any
    ) {

    }

    public get name() {
        return this._name;
    }

    public get summary() {
        return this._summary;
    }

    run(args : string[]) {
        this._handler(...args);
    }


}

export class CommandGroupEntry {
    constructor(private _name : string) {

    }

    private _methods : CommandEntry[] = [];

    public get name() {
        return this._name;
    }
    
    public get methods() {
        return this._methods;
    }

    public registerMethod(name : string, summary : string, handler : (args : string[]) => void) {
        this._methods.push(new CommandEntry(name, summary, handler));
    }

    public run(name : string, args : string[]) {
        let method = this.methods.find(x => x.name == name);
        method.run(args);
    }
}

export interface CommandOptions {
    group : string;
    name : string;
    summary? : string;
}

export function Command(options : CommandOptions = null) {
    return (target) => {
        InspectorCLI.preregister(options, target);
    }
}

interface PreregisteredCommand {
    options : CommandOptions;
    target : any;
}

interface CommandHandler {
    run(...args);
}

@Injectable()
export class InspectorCLI {
    constructor() {

    }

    static preregistrations : PreregisteredCommand[] = [];

    static preregister(options : CommandOptions, target : Function) {
        this.preregistrations.push({ options, target });
    }

    private commandGroups : CommandGroupEntry[] = [];

    install() {
        if (typeof window === 'undefined')
            return;

        // Register pre-registered commands 
        for (let preregistration of InspectorCLI.preregistrations) {
            let instance = new preregistration.target();
            this.registerCommand(preregistration.options.group, preregistration.options.name, preregistration.options.summary, function () {
                let args = [];
                for (let i = 0, max = arguments.length; i < max; ++i)
                    args[i] = arguments[i];

                instance.run(...args);
            })
        }

        Object.defineProperty(window, 'tyt', { get: () => { 
            
            let tyt : any = {};

            for (let commandGroup of this.commandGroups) {
                let tytGroup = {};
                tyt[commandGroup.name] = tytGroup;

                for (let command of commandGroup.methods) {
                    tytGroup[command.name] = function() {
                        let args : string[] = [];
                        for (let i = 0, max = arguments.length; i < max; ++i)
                            args[i] = arguments[i];
                        return command.run(args);
                    };
                }
            }

            tyt.help = () => {
                console.log("%cTYT 2.0", "font-size: 20pt; font-weight: bold;");
                console.log("%cInspector CLI", "font-size: 16pt;");
                console.log();
                console.log("tyt");
                console.log(`  .help() -- Show this help screen`);
                for (let commandGroup of this.commandGroups) {
                    console.log(`  .${commandGroup.name}`);
                    for (let command of commandGroup.methods) {
                        console.log(`    .${command.name}() -- ${command.summary}`);
                    }
                }
            }

            return tyt;
        } })

    }

    run(group : string, name : string, args : any[]) {
        let commandGroup = this.commandGroups.find(x => x.name == group);

        if (!commandGroup) {
            throw new Error(`No such command group ${group}`);

        }
        commandGroup.run(name, args);
    }

    registerCommand(group : string, name : string, summary : string, handler : (...args : any[]) => void) {
        let commandGroup = this.commandGroups.find(x => x.name == group);

        if (!commandGroup) {
            commandGroup = new CommandGroupEntry(group);
            this.commandGroups.push(commandGroup);
        }

        commandGroup.methods.push(new CommandEntry(name, summary, handler));
    }
}